import React from 'react';
import styled from 'styled-components';

import Animate from '../../../../../components/animate';
import NavigationSteps from '../navigation-steps';
import type { StepHeaderNavigationProps } from '../types';

const VerticalStepsWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.grey10};
  box-shadow: 0px 4px 7px 0px rgba(128, 128, 128, 0.3);
  padding-bottom: 1.5rem;
  position: absolute;
  top: 3.5rem;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndices.modal};
`;

const MobileExpandedNavigation = ({ handleGoToStep, hasStepZero = false }: StepHeaderNavigationProps) => (
  <Animate name="slideIn" appear>
    <VerticalStepsWrapper>
      <NavigationSteps hasStepZero={hasStepZero} isMobile handleGoToStep={handleGoToStep} />
    </VerticalStepsWrapper>
  </Animate>
);

export default MobileExpandedNavigation;
